module.exports = __webpack_public_path__ + "img/music_019.c712a84e.png";